import { useQuery } from "@redux-requests/react";
import _ from "lodash";
import moment from "moment";
import { types } from "../ducks";

const useCongress = () => {
  const {
    data: { data: congress, loading: congressLoading }
  } = useQuery({ type: types.GET_CONGRESS, defaultData: { data: {} } });

  return {
    congress: {
      ...congress,
      open: congress.published || moment(congress.startAt).isBefore(),
      closed: !congress.published && moment(congress.endAt).isBefore(),
      loaded: !_.isEmpty(congress)
    },
    congressLoading
  };
};

export default useCongress;
